// 대시보드(대표 전용) — 시안 v6 #pg-dash · renderDash, 계약 §7 GET /analytics/overview
import { useEffect, useState } from "react";
import AdminGate from "../../v6common/AdminGate";
import { showToast } from "../../../utill/utill";
import { kstShort } from "../../inquiry/view";
import { getMeta } from "./api";
import { FALLBACK_META } from "./format";
import useOverview from "./useOverview";
import { Kpis, Quality } from "./Kpis";
import { DailyPanel, HourlyPanel, AttentionPanel } from "./Panels";

function Dashboard({ go }) {
    const [days, setDays] = useState(30);
    const [meta, setMeta] = useState(FALLBACK_META);
    const { data: o, error, loading, reload } = useOverview(days);

    useEffect(() => {
        let alive = true;
        getMeta().then((m) => { if (alive && m?.statuses) setMeta(m); }).catch(() => {});
        return () => { alive = false; };
    }, []);

    const refresh = async () => {
        if (await reload()) showToast("대시보드를 새로고침했습니다.", "success");
    };

    return (
        <>
            <div className="top">
                <div><h1>대시보드</h1><p>Smart POS AI 기술지원 현황</p></div>
                <div className="top-act">
                    <div className="sys"><span>시스템 상태</span>
                        {error ? <b style={{ color: "var(--red)" }}><i className="fa-solid fa-triangle-exclamation"></i> 확인 필요</b>
                            : <b className="ok"><i className="fa-solid fa-circle"></i>정상</b>}
                    </div>
                    <div className="sys"><span>마지막 업데이트</span><b>{o ? kstShort(o.as_of) : "–"}</b></div>
                    <button className="btn" type="button" title="새로고침" aria-label="새로고침" disabled={loading} onClick={refresh}>
                        <i className={`fa-solid fa-rotate${loading ? " fa-spin" : ""}`}></i>
                    </button>
                </div>
            </div>
            {error && (
                <div className="actorbar" role="alert" style={{ marginBottom: 16 }}>
                    <i className="fa-solid fa-circle-exclamation"></i>{error}
                    <button className="btn btn-sm" type="button" style={{ marginLeft: "auto" }} onClick={reload}>다시 시도</button>
                </div>
            )}
            {!o && loading && <div className="panel"><div className="pn" style={{ color: "var(--tx3)" }}>대시보드를 불러오는 중…</div></div>}
            {o && (
                <div style={loading ? { opacity: 0.6 } : undefined}>
                    <Kpis o={o} go={go} />
                    <Quality o={o} />
                    <DailyPanel o={o} days={days} onDays={setDays} />
                    <div className="cols2-w mt">
                        <HourlyPanel o={o} />
                        <AttentionPanel items={o.attention || []} meta={meta} go={go} />
                    </div>
                </div>
            )}
        </>
    );
}

export default function DashboardPage({ go = () => {} }) {
    return (
        <main className="inq-r">
            <AdminGate ownerOnly>{() => <Dashboard go={go} />}</AdminGate>
        </main>
    );
}
